export default {
    pageTitle: "Download Apps",
    pageSubtitle: "Obtenha o APK Android mais recente de Africa Business, Egatee e JDE.",
    downloadApk: "Baixar APK",
    androidOnly: "Apenas APK Android. Abra esta pagina no navegador se o WeChat bloquear o download.",
    wechatTip: "O WeChat pode bloquear downloads de APK. Toque em ··· e escolha Abrir no navegador.",
    appMatata: "Africa Business",
    appMatataDesc: "App de oportunidades cross-border para fornecedores da China.",
    appEgatee: "Egatee",
    appEgateeDesc: "Marketplace B2B de atacado para varejistas africanos.",
    appJde: "JDE",
    appJdeDesc: "App de visitas e vendas para desenvolvimento de negocios."
}
